import i18n from './index';
import { normalizeLocale } from '../common/language';

const normalizeMessage = value => value.trim().replace(/[.!！。\s]+$/g, '');
const messageKeys = new Map();
function collectMessages(messages, prefix = '') {
  Object.keys(messages).forEach(key => {
    const path = prefix ? `${prefix}.${key}` : key;
    const value = messages[key];
    if (typeof value === 'string' && !value.includes('{')) {
      messageKeys.set(normalizeMessage(value), path);
    } else if (value && typeof value === 'object') {
      collectMessages(value, path);
    }
  });
}
['en', 'ja', 'kr', 'fr', 'es'].forEach(locale => collectMessages(i18n.getLocaleMessage(locale)));

// Only exact, known messages are translated. Do not guess a business error
// from a generic code such as 401 (used for many different failures here).
[
  ['인증 오류', 'common.login_required'],
  ['로그인해주세요', 'common.login_required'],
  ['로그인이 필요합니다', 'common.login_required'],
  ['작업 성공', 'common.success'],
  ['操作成功', 'common.success'],
  ['操作失败', 'common.request_failed'],
  ['鉴权错误', 'common.login_required']
].forEach(([message, key]) => messageKeys.set(normalizeMessage(message), key));

// Registration responses use legacy backend language strings, including when
// the backend locale differs from the language selected in the browser.
[
  ['auth.password_length', [
    'mmwscw', '密码位数错误！', 'Incorrect password length!',
    'パスワードの文字数が正しくありません！', '암호의 문자 수가 올바르지 않습니다!'
  ]],
  ['auth.invite_code_place', [
    'yqmbnwk', '邀请码不能为空！', 'Invite code cannot be empty!',
    '紹介コードを入力してください！', '추천 코드를 입력하세요!'
  ]],
  ['auth.invite_code_invalid', [
    'yqmbcz', '邀请码不存在！', 'Invite code does not exist!',
    '紹介コードが存在しません！', '추천 코드가 존재하지 않습니다!'
  ]],
  ['auth.register_success', [
    'zccg', '注册成功！', 'Registration successful!',
    '登録に成功しました！', '등록에 성공했습니다!'
  ]],
  ['auth.register_failed', [
    'zcsb', '注册失败！', 'Registration failed!',
    '登録に失敗しました！', '등록에 실패했습니다!'
  ]],
  ['auth.username_exists', [
    'yhycz', '用户已存在！', 'User already exists!',
    'ユーザーはすでに存在します！', '사용자는 이미 존재합니다!'
  ]],
  ['auth.username_invalid', [
    'yhmwscw', '用户名位数错误！', 'Incorrect username length!',
    'ユーザー名の文字数が正しくありません！', '사용자 이름의 문자 수가 올바르지 않습니다!'
  ]],
  ['auth.username_place', ['yhmbnwk']],
  ['common.request_failed', [
    'csyc', '参数异常！', 'Parameter abnormality!',
    'パラメーターが異常です！', '파라미터가 비정상입니다!'
  ]]
].forEach(([key, messages]) => {
  messages.forEach(message => messageKeys.set(normalizeMessage(message), key));
});

export function localizeApiMessage(message, code, locale = i18n.locale) {
  const language = normalizeLocale(locale);
  const text = typeof message === 'string' ? message.trim() : '';
  if (!text) return String(i18n.t(Number(code) === 200 ? 'common.success' : 'common.request_failed', language));
  const key = messageKeys.get(normalizeMessage(text));
  if (key) return String(i18n.t(key, language));
  // Unknown server-side Korean must not leak into non-Korean notifications.
  // The HTTP layer preserves the original message for diagnostics.
  if (language !== 'kr' && /[\u1100-\u11ff\u3130-\u318f\uac00-\ud7af]/.test(text)) {
    return String(i18n.t(Number(code) === 200 ? 'common.success' : 'common.request_failed', language));
  }
  return text;
}
